// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"355":"107d4f847dbb0b33","454":"a68bc5ebcf476faa"}[chunkId] + ".js";
};